import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from 'front-end/src/components/common/IconSVG'

const IconUpload: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconArchive" {...props}>
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.61523 12.1992C9.7207 12.0938 9.77344 11.9531 9.77344 11.7949V3.7793L11.8125 5.81836C11.918 5.92383 12.0586 5.97656 12.2168 5.97656C12.375 5.97656 12.498 5.92383 12.6211 5.80078C12.7266 5.69531 12.7793 5.57227 12.7793 5.41406C12.7793 5.25586 12.7266 5.13281 12.6035 5.00977L9.19336 1.6875L5.7832 5.00977C5.67773 5.13281 5.625 5.25586 5.625 5.41406C5.625 5.57227 5.67773 5.69531 5.7832 5.81836C5.83594 5.87109 5.90625 5.90625 5.97656 5.92383C6.04688 5.95898 6.11719 5.97656 6.1875 5.97656C6.25781 5.97656 6.32812 5.95898 6.39844 5.92383C6.46875 5.90625 6.53906 5.87109 6.5918 5.81836L8.64844 3.74414V11.7949C8.64844 11.9004 8.68359 11.9883 8.73633 12.0762C8.78906 12.1641 8.85938 12.2344 8.94727 12.2871C9.03516 12.3398 9.12305 12.3574 9.21094 12.3574C9.36914 12.3574 9.50977 12.3047 9.61523 12.1992Z"
        fill="currentColor"
      />
      <path
        d="M2.25 12.375C2.25 12.0643 1.99816 11.8125 1.6875 11.8125C1.37684 11.8125 1.125 12.0643 1.125 12.375V14.625C1.125 15.2463 1.62868 15.75 2.25 15.75H15.75C16.3713 15.75 16.875 15.2463 16.875 14.625V12.375C16.875 12.0643 16.6232 11.8125 16.3125 11.8125C16.0018 11.8125 15.75 12.0643 15.75 12.375V14.625H2.25V12.375Z"
        fill="currentColor"
      />
    </svg>
  </IconSVG>
)

export default IconUpload
